import { render } from "./Progres.vue?vue&type=template&id=46e23780"
import script from "./Progres.vue?vue&type=script&lang=js"
export * from "./Progres.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__